import { fetchTandaTerima } from '@pages/page-account-receivable/page-tanda-terima/action';
import { IStateReducer } from '@reducers/state';
import { connect } from 'react-redux';
import PageTandaTerimaDetailComponent from './component';

export const mapStateToProps = (state: IStateReducer) => ({
  isFetching: state.DefaultReducer.isFetching,
  metaData: state.DefaultReducer.metaData,
  tandaTerima: state.PageAccountReceivableReducer.tandaTerima,
});

export const mapDispatchToProps = (dispatch: any) => ({
  fetchTandaTerima: (code: string) => dispatch(fetchTandaTerima(code)),
});

export const PageTandaTerimaDetailContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PageTandaTerimaDetailComponent);

export default PageTandaTerimaDetailContainer;
